import React from 'react';

import getErrorMessage from '../utils/getErrorMessage';

class ErrorBoundary extends React.Component {

    state = {
        hasError: false,
        fallbackProps: null
    }

    static getDerivedStateFromError(error) {
        return { 
            hasError: true,
            fallbackProps: {
                error: getErrorMessage(error)
            }
        };
    }

    render() {
        const { children, fallback } = this.props;
        const { hasError, fallbackProps } = this.state;

        if (hasError) {
            return fallback != null ? fallback(fallbackProps) : null;
        } else {
            return children;
        }
    }
}

export default ErrorBoundary;
